<template lang="html">
  <v-dialog v-model="dialoggetProfile" max-width="500" persistent max-height="500px" style="overflow-y: hidden; border-radius: 20px !important;">
    <v-card style="border-radius:20px;">
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="">
            <v-layout row wrap>
              <p style="margin: 0px; color: white;">การใช้ข้อมูลผู้ใช้งาน แบบ onechat_token</p>
            </v-layout>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon flat @click="closeDialog();">
            <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text class="" style="height: 500px !important; overflow-x: hidden;">

        <p>รูปแบบ url เมื่อเลือก <i class="fas fa-check"></i> ต้องการข้อมูลผู้ใช้งาน แบบ onechat_token</p>
        <p>
          <span class="codeExampleUrl">url?onechat_token=0nIhJjZxI2YMxxx&expired_date=1587664633516</span>
        </p>



        <p>
          ผู้ใช้สามารถนำค่าของonechat_token ไปดึงข้อมูลของ user ที่ทำการเปิดเว็บไซต์ได้ จาก
        </p>
        <p>
          <span class="EndpointVerbPost">POST</span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="EndpointUrl">{{url}}</span>
        </p>
        <div>
          <strong>Request Header</strong>
          <code class="codecolor" style="">
            <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
          </code>
        </div>
<br>
        <div>
          <strong>Request Body (json)</strong>
          <code class="codecolor" style="">
    {
      <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"B12345xxxx"</span>,
      <span class="colorkey">"source"</span> : <span class="colorvalue">"0nIhJjZxI2YMxxx"</span>
    }
          </code>
        </div>
        <br>
        <div>
          <strong>ข้อมูลที่ได้ (Response)</strong>
          <code class="codecolor" style="">
    {
      <span class="colorkey">"data"</span> : {
        <span class="colorkey">"email"</span> : <span class="colorvalue">"onechat@one.th"</span>,
        <span class="colorkey">"nickname"</span> : <span class="colorvalue">"น้องonechat"</span>,
        <span class="colorkey">"one_id"</span> : <span class="colorvalue">"1234567"</span>,
        <span class="colorkey">"profilepicture"</span> : <span class="colorvalue">"https://onechat.th/pic/xhfsx"</span>
      },
      <span class="colorkey">"status"</span> : <span class="colorvalue">"Success"</span>
    }
          </code>
        </div>



      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialoggetProfile: false
  },
  data: () => ({
    url: process.env.APImanage + '/api/v1/getprofile'
  }),
  created () {
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialoggetProfile', false)
    }
  }
}
</script>

<style lang="css" scoped>
.btnOK {
  border-radius: 6px !important;
  color: white !important;
  background: #0e3660 !important;
  width: 150px;
  height: 35px;
}
.btnCancel {
  border-radius: 6px !important;
  color: #0e3660 !important;
  background: white !important;
  width: 150px;
  height: 35px;
  border: 2px solid #0e3660;
}
>>>.accent--text {
    color: #0e3660 !important;
    caret-color: #0e3660 !important;
}
>>>.v-input--selection-controls.v-input .v-label {
    color: #0e3660 !important;
}
>>>.theme--light.v-icon {
    color: rgb(14, 54, 96);
}
.EndpointUrl {
    color: #6D7D8D;
}
.urlcopy {

    display: none !important;
}
.EndpointUrl:hover .urlcopy {
    display: inline !important;
}
.EndpointVerbPost {
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #24446e;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    background-color: #24446e;
    color: #FFFFFF;
}
.codeExampleUrl {
  top: -2px;
  display: inline-block;
  padding: 4px 6px;
  border: 1px solid #24446e;
  font-size: 0.9rem;
  font-weight: bold;
  line-height: 1em;
  border-radius: 4px;
  background-color: #25446e52;
  color: #395171fa;
}
.codecolor {
  background: #2c3538;
  color: white;
  width: 100%;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
</style>



// WEBPACK FOOTER //
// src/components/BottomMenu/HowtoGetProfileDialog.vue